import React, { useState } from 'react';

const UserActivationWizard = ({ 
  user, 
  availableReports,
  licenseInfo,
  onActivateAndAssign,
  onSkip,
  loading
}) => {
  const [selectedReports, setSelectedReports] = useState([]);
  const [activateLicense, setActivateLicense] = useState(true);

  const userName = user.fullName || user.FullName || 'No Name Provided';
  const userEmail = user.email || user.Email;
  const hasAvailableLicenses = licenseInfo.available > 0;

  const toggleReportSelection = (reportId) => {
    setSelectedReports(prev => 
      prev.includes(reportId) 
        ? prev.filter(id => id !== reportId)
        : [...prev, reportId]
    );
  };

  const handleSubmit = async () => {
    await onActivateAndAssign({
      activateLicense: activateLicense && hasAvailableLicenses,
      reportIds: selectedReports
    });
  };

  const handleSelectAll = () => {
    if (selectedReports.length === availableReports.length) {
      setSelectedReports([]);
    } else {
      setSelectedReports(availableReports.map(r => r.reportID || r.ReportID));
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001,
      animation: 'fadeIn 0.3s ease-in'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '700px',
        maxHeight: '85vh',
        overflow: 'hidden',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Header */}
        <div style={{
          padding: '1.5rem',
          background: 'linear-gradient(90deg, #1B394B 0%, #5B91AC 100%)',
          color: 'white'
        }}>
          <h2 style={{ margin: '0 0 0.5rem 0', fontSize: '1.5rem', color: 'white' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16" style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '0.5rem', color: 'white' }}>
              <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
              <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
            </svg>
            User Created Successfully!
          </h2>
          <p style={{ margin: 0, fontSize: '0.95rem', opacity: 0.95, color: 'white' }}>
            Configure {userName}'s access
          </p>
        </div>

        {/* Content */}
        <div style={{
          padding: '1.5rem',
          maxHeight: '55vh',
          overflowY: 'auto'
        }}>
          {/* User Info */}
          <div style={{
            background: '#e8f4fd',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            border: '1px solid #bee5eb'
          }}>
            <div style={{ marginBottom: '0.5rem' }}>
              <strong style={{ color: '#0c5460' }}>Email:</strong> {userEmail}
            </div>
            <div>
              <strong style={{ color: '#0c5460' }}>Display Name:</strong> {userName}
            </div>
          </div>

          {/* License Activation Section */}
          <div style={{
            background: hasAvailableLicenses ? '#d4edda' : '#fff3cd',
            border: `2px solid ${hasAvailableLicenses ? '#c3e6cb' : '#ffc107'}`,
            borderRadius: '8px',
            padding: '1.25rem',
            marginBottom: '1.5rem'
          }}>
            <h4 style={{ 
              margin: '0 0 0.75rem 0', 
              color: hasAvailableLicenses ? '#155724' : '#856404',
              fontSize: '1.1rem'
            }}>
              Step 1: Activate License
            </h4>
            
            {hasAvailableLicenses ? (
              <>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '0.75rem',
                  marginBottom: '0.75rem'
                }}>
                  <label style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '0.5rem',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    color: '#155724'
                  }}>
                    <input
                      type="checkbox"
                      checked={activateLicense}
                      onChange={(e) => setActivateLicense(e.target.checked)}
                      style={{ 
                        width: '20px', 
                        height: '20px',
                        cursor: 'pointer'
                      }}
                    />
                    <span style={{ fontWeight: '600' }}>
                      Activate license for this user now
                    </span>
                  </label>
                </div>
                <div style={{ 
                  fontSize: '0.9rem', 
                  color: '#155724',
                  paddingLeft: '1.75rem'
                }}>
                  <strong>Available Licenses:</strong> {licenseInfo.available} of {licenseInfo.total}
                  <div style={{ marginTop: '0.25rem', fontSize: '0.85rem', fontStyle: 'italic' }}>
                    Without an active license, users cannot access any reports.
                  </div>
                </div>
              </>
            ) : (
              <div style={{ color: '#856404' }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  marginBottom: '0.5rem'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                  </svg>
                  <strong>No Available Licenses</strong>
                </div>
                <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem' }}>
                  All {licenseInfo.total} licenses are currently in use. 
                  {' '}You'll need to deactivate another user's license or purchase additional licenses before activating this user.
                </p>
              </div>
            )}
          </div>

          {/* Report Assignment Section */}
          <div style={{
            background: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            padding: '1.25rem'
          }}>
            <h4 style={{ 
              margin: '0 0 0.75rem 0', 
              color: '#495057',
              fontSize: '1.1rem'
            }}>
              Step 2: Assign Reports (Optional)
            </h4>
            
            {availableReports.length === 0 ? (
              <p style={{ 
                margin: 0, 
                color: '#6c757d', 
                fontStyle: 'italic',
                fontSize: '0.9rem'
              }}>
                No reports available. Upload reports in the Reports tab to assign them to users.
              </p>
            ) : (
              <>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '0.75rem'
                }}>
                  <p style={{ margin: 0, color: '#6c757d', fontSize: '0.9rem' }}>
                    Select reports to assign to {userName}
                  </p>
                  <button
                    onClick={handleSelectAll}
                    className="btn btn-secondary"
                    style={{ fontSize: '0.85rem', padding: '0.4rem 0.8rem' }}
                    disabled={loading}
                  >
                    {selectedReports.length === availableReports.length ? 'Deselect All' : 'Select All'}
                  </button>
                </div>

                <div style={{
                  maxHeight: '250px',
                  overflowY: 'auto',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px',
                  background: 'white'
                }}>
                  {availableReports.map((report, index) => {
                    const reportId = report.reportID || report.ReportID;
                    const reportName = report.reportName || report.ReportName;
                    const uploadDate = report.uploadDate || report.UploadDate;
                    const uploadedBy = report.uploadedByAdminName || report.UploadedByAdminName;
                    const isSelected = selectedReports.includes(reportId);

                    return (
                      <div
                        key={reportId}
                        onClick={() => toggleReportSelection(reportId)}
                        style={{
                          padding: '0.875rem',
                          backgroundColor: isSelected ? '#e3f2fd' : (index % 2 === 0 ? '#f8f9fa' : 'white'),
                          borderBottom: index < availableReports.length - 1 ? '1px solid #dee2e6' : 'none',
                          cursor: 'pointer',
                          transition: 'background-color 0.2s ease'
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => {}} // Handled by div click
                            style={{ 
                              marginRight: '0.75rem',
                              width: '18px',
                              height: '18px',
                              cursor: 'pointer'
                            }}
                          />
                          <div style={{ flex: 1 }}>
                            <div style={{ 
                              fontWeight: '600', 
                              marginBottom: '0.25rem',
                              color: '#495057'
                            }}>
                              {reportName}
                            </div>
                            <div style={{ fontSize: '0.8rem', color: '#6c757d' }}>
                              Uploaded: {new Date(uploadDate).toLocaleDateString()} by {uploadedBy || 'Unknown'}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {selectedReports.length > 0 && (
                  <div style={{
                    marginTop: '0.75rem',
                    padding: '0.75rem',
                    background: '#e3f2fd',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    color: '#0c5460'
                  }}>
                    <strong>{selectedReports.length}</strong> report{selectedReports.length !== 1 ? 's' : ''} selected for assignment
                  </div>
                )}
              </>
            )}
          </div>

          {/* Summary Notice */}
          {(activateLicense && hasAvailableLicenses) || selectedReports.length > 0 ? (
            <div style={{
              marginTop: '1.5rem',
              padding: '1rem',
              background: '#d1ecf1',
              border: '1px solid #bee5eb',
              borderRadius: '8px'
            }}>
              <h5 style={{ margin: '0 0 0.5rem 0', color: '#0c5460' }}>
                Summary
              </h5>
              <ul style={{ margin: 0, paddingLeft: '1.5rem', color: '#0c5460', fontSize: '0.9rem' }}>
                {activateLicense && hasAvailableLicenses && (
                  <li>User license will be activated</li>
                )}
                {selectedReports.length > 0 && (
                  <li>{selectedReports.length} report{selectedReports.length !== 1 ? 's' : ''} will be assigned</li>
                )}
                {!activateLicense && selectedReports.length === 0 && (
                  <li style={{ color: '#856404' }}>User will be created with inactive license and no reports</li>
                )}
              </ul>
            </div>
          ) : null}
        </div>

        {/* Footer */}
        <div style={{
          padding: '1rem 1.5rem',
          borderTop: '1px solid #dee2e6',
          background: '#f8f9fa',
          display: 'flex',
          justifyContent: 'space-between',
          gap: '0.75rem'
        }}>
          <button
            className="btn btn-secondary"
            onClick={onSkip}
            disabled={loading}
            style={{ flex: '0 0 auto' }}
          >
            Skip Setup
          </button>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            {(activateLicense && hasAvailableLicenses) || selectedReports.length > 0 ? (
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
                style={{ minWidth: '150px' }}
              >
                {loading ? 'Configuring...' : 'Complete Setup'}
              </button>
            ) : (
              <button
                className="btn btn-secondary"
                onClick={onSkip}
                disabled={loading}
              >
                Close
              </button>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default UserActivationWizard;
